<template>
    <div class="all">
        <div class="screen">
            <div class="item clearfix">
                <div class="corm fl clearfix">
					<span class="element cp" :class="{curr:searchData.state === 1}" @click="getList(1)">事件分析</span>
					<span class="element cp" :class="{curr:searchData.state === 2}" @click="getList(2)">往期事件</span>
				</div>
                <div class="fr">
                    <button class="btn btn-blue" @click="addEvents">新建事件</button>
                </div>
            </div>
        </div>
        <div class="warp mt20">
            <div class="warp-body clearfix">
                <ul class="events">
                    <li class="events-item" v-for="(item,index) in newsList" :key="index" style="min-height:364px">
                        <div class="events-item-hd">
                            <h3 class="ovhidden2">{{item.name}}</h3>
                            <p class="mt5 fs12">{{item.beginTime}} ~ {{item.endTime}}</p>
                            <div class="total btn-blue" :class="searchData.state ===1?'oncur':'outcur'" @click="jumpInformation(item.id,item.beginTime,item.endTime,item.name,null)">相关信息{{item.total}}条</div>
                        </div>
                        <div class="events-item-bd" style="min-height:172px">
                            <div class="" v-show="item.status === 2">
                                <!-- 未过期显示 -->
                                <ul class="events-array clearfix" v-show="item.state !== 2">
                                    <li class="events-array-item cp" v-for="(items,indexs) in item.platformDistribution" :key="indexs" @click="jumpInformation(item.id,item.beginTime,item.endTime,item.name,items.key)">{{items.name}}<p class="color-blue">{{items.value}}</p></li>
                                </ul>
                                <!-- 过期显示 -->
                                <div class="events-guoqi" v-show="item.state === 2 && item.status !== -1">
                                    <img src="/static/images/guoqi.png" alt="" width="101">
                                </div>
                                <div class="events-operation mt15">
                                    <a class="icons eye-icon" title="预览" href="javascript:void(0);" @click="lookEvent('html',item.id,item.beginTime,item.endTime,item.name,item.qrUrl)"></a>
                                    <i class="icons word-icon cp" title="下载Word" @click="lookEvent('word',item.id)"></i>
                                    <i class="icons pdf-icon cp" title="下载PDF" @click="lookEvent('pdf',item.id)"></i>
                                    <i class="icons edit-icon cp" title="修改" @click="editEvents(item.id);"></i>
                                    <i class="icons del-icon cp" title="删除" @click="delEvents(item.id);"></i>
                                </div>
                            </div>
							<div class="" v-show="item.status === -1">
								<!-- 失败显示 -->
							    <div class="events-guoqi">
							        <img src="/static/images/shibai.svg" alt="" width="101">
							    </div>
							    <div class="events-operation mt15">
							        <i class="icons edit-icon cp" title="修改" @click="editEvents(item.id);"></i>
							        <i class="icons del-icon cp" title="删除" @click="delEvents(item.id);"></i>
							    </div>
							</div>
                            <div class="events-load" v-show="item.status !== 2&&item.status !== -1&&item.status !== -2">
                                <img :src="'/static/images/loading1.gif'"/>
                                <p class="mt10">信息正在努力生成中，请稍后</p>
                            </div>
                            <div class="events-load" v-show="item.status === -2">
                                <div class="events-operation mt15">
                                    <i class="icons edit-icon cp" title="修改" @click="editEvents(item.id);"></i>
                                    <i class="icons del-icon cp" title="删除" @click="delEvents(item.id);"></i>
                                </div>
                                <p class="mt10">事件未开始</p>
                            </div>
                        </div>
                    </li>
                </ul>
                <div class="no-data no-datas" v-if="nodata"><span class="text">暂无数据</span></div>
            </div>
        </div>
        <!-- 下载选项 -->
        <Dialog ref="addEventModal" :title="eventData.id === '' ? '新建事件' : '编辑事件'" btnText="保存" :callback="saveAddEvents" type="normal" width="700">
            <div slot="mdBox">
                <div class="form-warp max-limit" style="height:420px">
                    <div class="item clearfix">
                        <span class="name fl"><span class="color-red">*</span>事件名称：</span>
                        <div class="input-father">
                            <input maxlength="50" v-model.trim="eventData.name" type="text" placeholder="请输入事件名称" class="input-text">
                        </div>
                    </div>
                    <div class="item clearfix">
                        <span class="name fl">时间：</span>
                        <div class="fl">
                            <vue-datepicker-local v-model="timeRange" format="YYYY-MM-DD HH:mm:ss" :disabled-date="disabledDate"  show-buttons  @confirm="selectedDate"/>
                        </div>
                    </div>
                    <div class="item mt15 clearfix">
                        <span class="name fl"><span class="color-red">*</span>分析词:</span>
                        <div class="input-father no-hidden">
                            <div class="clearfix">
                                <div class="tool-group fl">
                                    <button class="btn" @click="addMonitorSymbol('+');">+</button>
                                    <button class="btn" @click="addMonitorSymbol('|');">|</button>
                                    <button class="btn" @click="addMonitorSymbol('()');">( )</button>
                                    <button class="btn btn-blue" @click="getParticiple();">获取分词</button>
                                </div>
                                <div class="grid-info grid-info-left ml20">
                                    <i class="icons icons-question-circle"></i>
                                    <p class="grid-tip">+号表示与关系，|号表示或关系。示例：华为+（手机 | 充电器+数据线），需要监测的数据即为包含华为+手机，或者包含华为+充电器+数据线的文章</p>
                                </div>
                            </div>
                            <textarea name="" ref="seniorTextarea" @input="checkInputWords(eventData.keywordsInit,1)" @blur="checkBlurWords(eventData.keywordsInit,1)" v-model.trim="eventData.keywordsInit" placeholder="请输入分词" class="input-textarea mt10"></textarea>
                        </div>
                    </div>
                    <div class="item mt15 clearfix">
                        <span class="name fl">排除词:</span>
                        <div class="input-father">
                            <textarea name="" @input="checkInputWords(eventData.keywordsExclude,2)" @blur="checkBlurWords(eventData.keywordsExclude,2)" v-model.trim="eventData.keywordsExclude" placeholder="多个排除词之间以 , 隔开，词组之间为“与”关系" class="input-textarea"></textarea>
                        </div>
                    </div>
                    <div v-if="supportEventOfflineSend===1">
                        <h4 class="mt15">数据离线包接收设置<span class="color-red">（*事件结束后，自动发送数据离线包至接收人邮箱）</span></h4>
                        <div class="item mt15 clearfix">
                            <span class="name fl">邮箱接收人:</span>
                            <div class="input-father checkbox-group">
                                <label class="checkbox-box" v-for="(item,index) in contactsList" :key="index">
                                    <label class="checkbox-warp fl"><input name="" type="checkbox" v-model="contact" :value="item.id" class="checkbox"> <i class="icons checkbox-icon"></i></label>
                                    <div class="hidden ac">{{item.username}}</div>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Dialog>
        <!-- 分析词报错提示 -->
        <Dialog ref="errorAlert" type="alert">
            <div slot="mdBox">
                <h3>以下标红处有错误:</h3>
                <p class="mt10" v-html="seniorMonitorHtml"></p>
            </div>
        </Dialog>
	</div>
</template>
<script>
import Dialog from '../components/dialog.vue'
import VueDatepickerLocal from 'vue-datepicker-local'
import city from '../components/city.vue';
import moment from 'moment';
export default {
    components:{VueDatepickerLocal,city,Dialog},
    data() {
        const min = ''
        const max = ''
        return {
            flagTime:true,
            seniorMonitorHtml:'',//分析词爆红提示
            timeRange: [min, max],
            searchData:{
                state:1,
                name:''
            },
            contact:[],
            eventData:{
                id:'',
                name:'',
                contact:[],
                keywordsInit:'',//分析词
                keywordsExclude:'',//排除词
                beginTime:'',//开始时间
                endTime:''//结束时间
            },
            contactsList:[],//邮箱联系人列表
            nodata:false,
            isShowNew:true,//判断所选时间是否超过90天 true是没有
            newsList:[],//新闻列表
            listTimer:'',//请求接口定时器
            supportEventOfflineSend:-1
        }
    },
    mounted() {
        let that = this;
        that.getList(1);
        that.getContactsList();
    },
    created() {
        this.supportEventOfflineSend = JSON.parse(sessionStorage.getItem('planStorage')).supportEventOfflineSend;
    },
    beforeDestroy() {
        window.clearTimeout(this.listTimer);
    },
    methods: {
        // 获取列表
        getList (type){
            let that = this;
            that.searchData.state = type;
            window.clearTimeout(that.listTimer);
            that.$api.get('event/event/list',that.searchData,r =>{
                that.$utils.returnCode(r,function(){
                    that.newsList = r.data;
                    if(r.data.length <= 0){
                        that.nodata = true;
                    }else{
                        let arr = r.data.filter((item) =>{return item.status !== 2&&item.status !== -2})
                        if(arr.length > 0){
                            that.listTimer = setTimeout(() =>{
                                that.getList(type);
                            },5000)
                        }else{
                            window.clearTimeout(that.listTimer);
                        }
                        that.nodata = false;
                    }
                })
            })
        },
        // 获取邮箱联系人
        getContactsList (){
            let that = this;
            that.$api.get('user/contact/list', {type:'email'}, r => {
                that.$utils.returnCode(r,function(){
                    that.contactsList = r.data;
                })
            })
        },
        // 跳转信息列表
        jumpInformation (id,startDate,endDate,name,type){
            if(this.searchData.state === 2){
                return false;
            }
            let data = {
                id:id,
                startDate:startDate,
                endDate:endDate,
                name:name,
                type:type
            }
            this.$router.push({path:'/eventsInfomation',query:data})
        },
        disabledDate(time){
            let day = this.$parent.timeSection;//获取当前用户的时间范围权限
            let nowTime = this.$utils.getNowDate();//今天时间
            let startDate = this.$utils.getBeforeDay(nowTime,day);//根据时间权限获取最早时间
            let n = nowTime.split(' ');
            startDate = startDate + ' ' + n[1]
            let number = this.$utils.dateToMillisecond(startDate);//将获取的最早时间转化成毫秒
            if(time.getTime() < number||time.getTime() === number) return true;
        },
        selectedDate (date) {
            let that = this;
            let flag =  this.$utils.selectTime(date,this.$store.state.show.companyinfo.timeControlWindow)
            this.flagTime = flag
            if(!flag){
                return
            }
            let timeRange = that.timeRange;
            that.isShowNew = true;
            //进页面获取时间数据
            let startTime = that.$utils.dateConversion(timeRange[0],1);
            let endTime = that.$utils.dateConversion(timeRange[1],1);
            let day = that.$utils.getDateDiff(startTime,endTime);
            let day_ = this.$parent.timeSection;//获取当前用户的时间范围权限
            if(day > day_){
                that.$utils.alertText('时间跨度最大限制'+day_+'天','',1500);
                that.isShowNew = false;
                return;
            }
            this.eventData.beginTime = startTime;
            this.eventData.endTime = endTime;
        },
        // 新建事件
        addEvents (){
            this.eventData = {
                id:'',
                name:'',
                keywordsInit:'',//分析词
                keywordsExclude:'',//排除词
                beginTime:'',//开始时间
                endTime:''//结束时间
            }
            let nowTime = this.$utils.getNowDate();//今天时间
            let startDate = this.$utils.getBeforeDay(nowTime,2,1);//根据时间权限获取最早时间
            let endDate = this.$utils.getBeforeDay(nowTime,-2,1);//根据时间权限获取最早时间
            this.timeRange = [new Date(moment().add(-2, 'd')), new Date(moment().add(2, 'd'))]
            this.eventData.beginTime = startDate;
            this.eventData.endTime = endDate;
            this.$refs.addEventModal.showMaskFun();
        },
        // 获取分词
        getParticiple (){
            let that = this;
            let name = that.eventData.name;
            if(name === ''){
                that.$utils.alertText('请先填写事件名称');
                return;
            }
            that.$api.get('event/event/fenci',{name:name},r =>{
                that.$utils.returnCode(r,function(){
                    let len = that.eventData.keywordsInit.length;
                    if(r.data.length > 0){
                        if(that.eventData.keywordsInit.indexOf(r.data) < 0){
                            if(len > 0){
                                that.eventData.keywordsInit += '+' + r.data;
                            }else{
                                that.eventData.keywordsInit = r.data;
                            }
                        }
                    }else{
                        that.$utils.alertText('暂无分词');
                    }
                })
            })
        },
        // 分析词符号添加
        addMonitorSymbol (content) {
            // that.seniorMonitor
            let textarea = this.$refs.seniorTextarea;
            let startPos = textarea.selectionStart;
            let endPos = textarea.selectionEnd;
            if (startPos === undefined || endPos === undefined) {
               return;
            }
            let txt = textarea.value;
            let result = txt.substring(0, startPos) + content + txt.substring(endPos)
            this.eventData.keywordsInit = result;
            textarea.focus();
        },
        // 分析词检测标红提示
        seniorMonitorError(value) {
            let that = this;
            let patterns = /^(\+|\|)|\+{2}|\|{2}|\({2}|\+\||\|\+|\(\+|\+\)|\(\||\|\)|\([^\)]*\(|\)[^\(]*\)|\)\(|\(\s*\)|[^\+\|]\(|\)[^\+\|]|(\+|\|)$/g;
            if(!patterns.test(value)) {
                return true;
            } else {
                let index = patterns.lastIndex;
                let text = '';
                if(index === 1){
                    text = value.slice(index-1,index+1);
                }else{
                    text = value.slice(index-2,index+1);
                }
                let html = '<i class="color-red">'+text+'</i>'
                let start = value.substring(0,index-2);
                let end = value.substring(index+1,value.length);
                that.seniorMonitorHtml = start+html+end;
                that.$refs.errorAlert.showMaskFun();
                return false;
            }
        },
        // 校验
        checkInputWords (data,type){
            data = data.replace(/,,/g,",");
            data = data.replace(/，，/g,",");
            data = data.replace(/，,/g,",");
            data = data.replace(/,，/g,",");
            data = data.replace(/，/g,",");
            data = data.replace(/（/g, '(');
            data = data.replace(/）/g, ')');
            if(data[0] === '，' || data[0] === ','){
                data = data.substr(1)
            }
            if(type === 1){
                this.eventData.keywordsInit = data;
            }else if(type === 2){
                this.eventData.keywordsExclude = data;
            }
        },
        checkBlurWords (data,type){
            let len = data.length;
            if(data[len-1] === '，' || data[len-1] === ','){
                data = data.substr(0, len - 1);
            }
            if(type === 1){
                this.eventData.keywordsInit = data;
            }else if(type === 2){
                this.eventData.keywordsExclude = data;
            }
        },
        //保存事件
        saveAddEvents (){
            let that = this;
            if(!this.flagTime){
                this.$utils.alertText(`可选择时间范围最大为${this.$store.state.show.companyinfo.timeControlWindow}天`)
                return
            }
            let data = that.eventData;
            data.contact = that.supportEventOfflineSend === -1?[]:that.contact;
            if(data.name === ''){
                that.$utils.alertText('请填写事件名称');
                return;
            }else if(!that.isShowNew){
                that.$utils.alertText('时间跨度最大限制90天');
                return;
            }else if(data.keywordsInit === ''){
                that.$utils.alertText('请填写分析词');
                return;
            }else if(!that.seniorMonitorError(data.keywordsInit)){
                return;
            }
            that.$refs.addEventModal.closeMask();
            that.$parent.loadModal(true,'正在保存...');
            that.$api.post('event/event/edit',{data:data},r =>{
				if(r.code !== 10001){
					that.$utils.returnCode(r,function(){
					    that.$parent.showLoad = false;
					    that.$utils.alertText('保存成功');
					    that.$store.dispatch('show/changeToast',{text:'保存成功'})
					    that.getList(1);
					})
				}else{
					that.$parent.showLoad = false;
					that.$utils.alertText(r.msg);
					that.getList(1);
				}
            })
            setTimeout(()=>{
                that.$parent.showLoad = false;
                that.getList(1);
            },1500)
        },
        // 预览事件
        lookEvent (type,id,startDate,endDate,name,qrUrl){
            let that = this;
            that.$api.get('event/event/report',{type:type,eventId:id},r =>{
                that.$utils.returnCode(r,function(){
                    if(type === 'html'){
                        if(r.data.templatType == 2){
                            window.open(r.data.url);
                        }else{
                            let data = {
                                id:id,
                                startDate:startDate,
                                endDate:endDate,
                                name:name,
                                url:qrUrl,
                                iframUrl:r.data.url
                            }
                            let url = that.$router.resolve({path:'/eventsHtml',query:data})
                            window.open(url.href,'_blank')
                        }
                    }else{
                        window.open(r.data.url);
                    }
                })
            })
        },
        // 删除事件
        delEvents (id){
            let that = this;
            that.$confirm('是否删除事件？').then(() => {
				let data = {
					conditionId:id
				}
				that.$parent.loadModal(true,'正在删除...');
				that.$api.get('event/event/delete',{eventId:id},r =>{
					that.$parent.showLoad = false;
					that.$utils.returnCode(r,function(){
                        that.$utils.alertText('删除成功');
                        that.$store.dispatch('show/changeToast',{text:'删除成功'})
                        that.getList(that.searchData.state);
					});
				})
			})
        },
        // 修改事件
        editEvents (id){
            let that = this;
            that.$confirm('修改会删除事件原有数据，根据新规则补全历史数据，确认修改？').then(() => {
				let data = {
					conditionId:id
				}
				that.$parent.loadModal(true,'正在获取数据...');
				that.$api.get('event/event/info',{eventId:id},r =>{
					that.$parent.showLoad = false;
					that.$utils.returnCode(r,function(){
                        that.eventData = {
                            id:r.data.id,
                            name:r.data.name,
                            contact : r.data.contact,
                            keywordsInit:r.data.keywordsInit,//分析词
                            keywordsExclude:r.data.keywordsExclude,//排除词
                            beginTime:r.data.beginTime,//开始时间
                            endTime:r.data.endTime//结束时间
                        }
                        that.contact = r.data.contact;
                        that.timeRange = [r.data.beginTime,r.data.endTime];
                        that.$refs.addEventModal.showMaskFun();
					});
				})
			})
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/page/eventsPath.vue